export const phoneNumberSanitizationMatcher = new RegExp(' |-');

export function extractFirstAndLastNameOrNull(
    displayName: string | null | undefined
): { firstName: string | null, lastName: string | null} | null {
  if(displayName == null) {
    return null;
  }

  return extractFirstAndLastName(displayName);
}

export function extractFirstAndLastName(displayName: string | null): { firstName: string | null, lastName: string | null} {
  let firstName: string | null = null;
  let lastName: string | null = null;

  const trimmedDisplayName = displayName?.trim();

  if(trimmedDisplayName != null && trimmedDisplayName.length > 0) {
    const indexOfSpace: number = trimmedDisplayName.lastIndexOf(' ');
    if(indexOfSpace > 0) {
      firstName = trimmedDisplayName.substring(0, indexOfSpace);
      lastName = trimmedDisplayName.substring(indexOfSpace + 1, trimmedDisplayName.length);

      lastName = lastName.length > 0 ? lastName : null;
    }
    else {
      firstName = trimmedDisplayName.trim();
      firstName = firstName.length > 0 ? firstName : null;
    }
  }

  return { firstName, lastName };
}

export function getFormattedName(firstName: string | null, lastName: string | null): string | null {
  if(firstName && firstName.length !== 0 && lastName && lastName.length !== 0) {
    return `${firstName} ${lastName}`;
  }
  if(firstName && firstName.length !== 0) {
    return firstName;
  }
  if(lastName && lastName.length !== 0) {
    return lastName;
  }

  return null;
}

export function getInitialsFromName(firstName: string | null, lastName: string | null): string | null {
  if(firstName && firstName.length !== 0 && lastName && lastName.length !== 0) {
    return `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`;
  }
  if(firstName && firstName.length !== 0) {
    return firstName[0].toUpperCase();
  }
  if(lastName && lastName.length !== 0) {
    return lastName[0].toUpperCase();
  }

  return null;
}

export function assertUnreachable(x: never): never {
  throw new Error('Unreachable case' + x);
}
